// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../image/breadcrumb-bg2.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBvbHlsaW5lIHBvaW50cz0iOSA2IDE1IDEyIDkgMTgiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBvbHlsaW5lIHBvaW50cz0iMTUgNiA5IDEyIDE1IDE4Ii8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* About-usPage */
.text-white,
.breadcrumb {
  padding: 0px 34px;
}

.breadcrumb.breadcrumb-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) rgba(36, 29, 57, 0.8) no-repeat;
  background-size: cover;
}

.breadcrumb-list {
  /* background: url(../img/bg/breadcrumb-bg.png) rgba(36, 29, 57, 0.8) no-repeat; */
  background-size: cover;
  background-blend-mode: multiply;
  padding: 60px 0;
  position: relative;
  margin-top: 70px;
}

.breadcrumb-list:before {
  position: absolute;
  top: 60px;
  left: 40px;
  width: 20px;
  height: 20px;
}

.breadcrumb-list:before,
.breadcrumb-list:after {
  content: "";
  background: linear-gradient(
    105.55deg,
    #085a6c -6.68%,
    #269089 43.13%,
    #7abc82 96.15%
  );
  border-radius: 100%;
}

.breadcrumb-list span.primary-right-round {
  content: "";
  position: absolute;
  right: 50px;
  bottom: 50px;
  width: 13px;
  height: 13px;
  background: #23b33a;
  border-radius: 13px;
}

.breadcrumb-list .container {
  position: relative;
}

.breadcrumb-list h1 {
  margin-bottom: 15px;
}

.breadcrumb-list ol {
  position: relative;
  color: #ffffff;
}

.breadcrumb-list ol li {
  display: inline-block;
  position: relative;
  z-index: 1;
}

.breadcrumb-list ol .active {
  color: #ffffff;
}

ul li {
  list-style-type: none;
}

.featured-venues .blogstyle {
  font-size: 1.5rem !important;
}

.breadcrumb-list ol:after {
  position: absolute;
  right: 0;
  bottom: -76px;
  width: 147px;
  height: 74px;
  content: "";
  background: linear-gradient(
    105.55deg,
    #085a6c -6.68%,
    #269089 43.13%,
    #7abc82 96.15%
  );
  border-top-left-radius: 84px;
  border-top-right-radius: 84px;
}

.breadcrumb-list:after {
  content: "";
  background: linear-gradient(
    105.55deg,
    #085a6c -6.68%,
    #269089 43.13%,
    #7abc82 96.15%
  );
  border-radius: 100%;
}

.breadcrumb-item a {
  font-size: 16px !important;
}

.breadcrumb-item.active {
  font-size: 16px !important;
}

.aboutus-info {
  padding-top: 50px;
  margin-bottom: 60px;
}

.corner-radius-10 {
  border-radius: 10px;
}

.about-div{
  padding: 40px 0px 0px 0px;
}

.aboutus-info .vision-mission {
  margin-top: 40px;
  padding: 0px 34px;
}

.aboutus-info .vision-mission h2 {
  margin-bottom: 12px;
  color: #192335;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.3;
}

.aboutus-info p {
  margin-bottom: 10px;
  .vision-mission p {
    font-size: 15px;
    color: #555;
    line-height: 1.7;
    margin-bottom: 12px;
  }
}

.steps-about {
  padding-left: 18px;
}

.steps-about li {
  margin-bottom: 8px;
  font-size: 14px;
  list-style-type: disc;
}

.aboutus-info p:last-child {
  margin-bottom: 40px;
}

.aboutus-info .vision-mission .mission-bg {
  background: #00bfb4;
  border-radius: 10px;
  padding: 28px;
  color: #ffffff;
}

.aboutus-info .vision-mission .mission-bg h2 {
  color: #ffffff;
  margin-top: 22px;
  margin-bottom: 10px;
}

.aboutus-info .vision-mission h2 {
  margin-bottom: 12px;
}

.aboutus-info .vision-mission .mission-bg p {
  margin-bottom: 0;
}

.heading {
  text-align: center;
}

/* ------------ */

/*  */

.featured-venues {
  background: #f9f9f6;
  position: relative;
}

.section-heading {
  text-align: center;
  margin: 0 0 40px;
}

.section-heading h2 {
  position: relative;
  margin: 0 0 15px;
  z-index: 1;
}

.section-heading h2 span {
  font-size: inherit;
  background: linear-gradient(
    105.55deg,
    #085a6c -6.68%,
    #269089 43.13%,
    #7abc82 96.15%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.featured-slider-group {
  padding: 15px 15px 20px;
}

.featured-slider-group .featured-venues-item {
  padding-bottom: 20px;
}

.listing-item .listing-img {
  position: relative;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
}

.slick-next:before,
.slick-prev:before {
  display: none !important;
  content: none !important;
}

.slick-next:hover,
.slick-prev:hover {
  background-color: #097e52 !important;
}

.slick-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 20px 20px !important;
  width: 36px !important;
  height: 36px !important;
  position: absolute !important;
  top: 50%;
  transform: translate(-24%, 0%) !important;
  background-color: #ffffff !important;
  border-radius: 50% !important;
  z-index: 10 !important;
  box-shadow: 0px -1px 23px rgba(212, 212, 212, 0.75) !important;
}

.slick-prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 20px 20px !important;
  left: -23px !important;
  width: 36px !important;
  height: 36px !important;
  position: absolute !important;
  top: 50%;
  transform: translate(21%, 0%) !important;
  background-color: #ffffff !important;
  border-radius: 50% !important;
  z-index: 10 !important;
  box-shadow: 0px -1px 23px rgba(212, 212, 212, 0.75) !important;
}

.listing-item .list-reviews {
  margin: 0 0 15px;
}

.listing-item .list-reviews {
  display: flex;
  justify-content: space-between;
}

.listing-item .list-reviews span {
  font-size: 14px;
}

.listing-item .rating-bg {
  background: #ffaa00;
  color: #ffffff;
  border-radius: 5px;
  margin-right: 7px;
  width: 31px;
  height: 28px;
}

.listing-item .rating-bg {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.listing-item .list-reviews span {
  font-size: 14px;
}

.listing-item .list-reviews .fav-icon {
  width: 30px;
  height: 30px;
  border: 1px solid #eaedf0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #192335;
  display: flex;
}



.listing-item .listing-title a {
  color: #192335;
}

.listing-item .listing-title-page {
  margin: 0 0 15px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

.listing-item .listing-title-page h3 {
  font-weight: 600;
  font-size: 24px;
}

.listing-item .listing-title-page a {
  color: #192335;
}

.listing-item .listing-details-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.listing-item .listing-details-group li {
  color: #192335;
  margin-bottom: 15px;
}

.listing-item .listing-content ul li span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
}

.listing-item .listing-details-group li i {
  font-size: 22px !important;
}

.listing-item .listing-details-group li .primary-text {
  margin: 0 0 0 10px;
  color: #097e52;
}

.listing-item .listing-button {
  padding: 15px 0 0;
  border-top: 1px solid #eaedf0;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.listing-item .listing-venue-owner a {
  align-items: center;
  display: flex;
}

.listing-venue-owner .navigation {
  font-weight: 400;
}

.listing-venue-owner img {
  border-radius: 50%;
  border: 3px solid #eaedf0;
  width: 45px;
  height: 45px;
  margin-right: 5px;
}

.user-book-now {
  color: #6b7385;
  font-size: 14px;
  font-weight: 500;
}

.user-book-now span i {
  color: #192335;
}

.listing-img img {
  height: 200px;
  object-fit: cover;
  width: 100% !important;
}

/* cards */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.wrap {
  background: #f4fafa;
  padding: 48px 32px 0px 32px;
}
.inner {
  margin: 0 auto;
}

/* TOP INTRO */
.intro {
  background: white;
  border-radius: 14px;
  border: 0.5px solid #d0eeea;
  padding: 32px 36px;
  margin-bottom: 28px;
}
.intro h2 {
  font-size: 24px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 14px;
}
.intro h2 span {
  color: #0f9b8e;
}
.intro p {
  font-size: 15px;
  color: #4a6b68;
  line-height: 1.8;
  margin-bottom: 8px;
}
.intro p:last-child {
  margin-bottom: 0;
}

/* TWO COL */
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 28px;
}

/* STORY */
.story-card {
  background: white;
  border-radius: 14px;
  border: 0.5px solid #d0eeea;
  padding: 28px;
}
.section-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 17px;
  font-weight: 500;
  color: #0f9b8e;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.section-label::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 2px;
  background: #0f9b8e;
  border-radius: 2px;
}
.story-card h3 {
  font-size: 20px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 16px;
}
.story-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 12px;
}
.story-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f9b8e;
  flex-shrink: 0;
  margin-top: 7px;
}
.story-item p {
  font-size: 13px;
  color: #4a6b68;
  line-height: 1.7;
}

/* ABOUT BOX */
.about-card {
  background: #0f9b8e;
  border-radius: 14px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.about-card h3 {
  font-size: 23px;
  font-weight: 500;
  color: white;
}
.about-card p {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.8;
}
.about-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.about-tag {
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 0.5px solid rgba(255, 255, 255, 0.3);
}

/* HOW IT WORKS */
.how-section {
  background: white;
  border-radius: 14px;
  border: 0.5px solid #d0eeea;
  padding: 28px 32px;
  margin-bottom: 28px;
}
.how-section h3 {
  font-size: 20px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 6px;
}
.how-section .sub {
  font-size: 15px;
  color: #4a6b68;
  margin-bottom: 24px;
}
.steps-about {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  position: relative;
}
.steps-about::before {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  height: 1.5px;
  background: #c2e8e4;
  z-index: 0;
}
.step {
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 0 8px;
}
.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #0f9b8e;
  color: white;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  border: 3px solid #f4fafa;
}
.step h4 {
  font-size: 13px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 4px;
}
.step p {
  font-size: 12px;
  color: #4a6b68;
  line-height: 1.6;
}

/* WHY CHOOSE */
.why-section {
  margin-bottom: 28px;
}
.why-section h3 {
  font-size: 20px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 6px;
}
.why-section .sub {
  font-size: 15px;
  color: #4a6b68;
  margin-bottom: 20px;
}
.why-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.why-card {
  background: white;
  border-radius: 14px;
  border: 0.5px solid #d0eeea;
  padding: 20px;
}
.why-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #e6f9f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-bottom: 12px;
}
.why-card h4 {
  font-size: 13px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 5px;
}
.why-card p {
  font-size: 12px;
  color: #4a6b68;
  line-height: 1.65;
}

/* BOOK TODAY */
.book-section {
  background: white;
  border-radius: 14px;
  border: 0.5px solid #d0eeea;
  padding: 28px 32px;
  margin-bottom: 28px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: center;
}
.book-section h3 {
  font-size: 20px;
  font-weight: 500;
  color: #0a2e2b;
  margin-bottom: 10px;
}
.book-section p {
  font-size: 15px;
  color: #4a6b68;
  line-height: 1.75;
  margin-bottom: 8px;
}
.book-section p:last-of-type {
  margin-bottom: 0;
}
.book-visual {
  background: #e6f9f7;
  border-radius: 12px;
  width: 140px;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px;
}
.book-visual .big-icon {
  font-size: 36px;
}
.book-visual p {
  font-size: 11px;
  color: #0f9b8e;
  text-align: center;
  font-weight: 500;
  line-height: 1.4;
}

/* TAGLINE */
.tagline {
  background: #0a2e2b;
  border-radius: 14px;
  padding: 32px;
  text-align: center;
}
.tagline p {
  font-size: 20px;
  font-weight: 500;
  color: white;
  letter-spacing: 0.3px;
}
.tagline p span {
  color: #4ecdc4;
}
.tagline .sub {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: 8px;
  font-weight: 400;
  letter-spacing: 0;
}

/* SPORTS ICONS */
.sports-icons {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.sports-icons span {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0px 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 20px;
  transition: 0.3s ease;
  cursor: pointer;
}

.sports-icons span:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.22);
}

/* OfferCards.css */

.offer-section {
  padding: 30px 40px;
  background: #f7f9fc;
  margin: 20px 0px;
}

.offer-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #092642;
  margin-bottom: 50px;
  font-family: "Outfit", sans-serif;
}

.offer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.offer-card {
  position: relative;
  background: #ffffff;
  border-radius: 22px;
  padding: 30px 24px;
  overflow: hidden;
  min-height: 226px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;
}

.offer-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

.wave-bg {
  position: absolute;
  bottom: -10px;
  left: -20px;
  width: 140%;
  height: 90px;
  background: #eef4ff;
  border-radius: 50%;
}

.card-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-content h3 {
  font-size: 18px;
  color: #495E76;
  font-weight: 600;
  line-height: 1.5;
}

.arrow-btn {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  background: #eef3ff;
  color: #5b7cff;
  font-size: 22px;
  cursor: pointer;
  align-self: flex-end;
  transition: all 0.3s ease;
}

.arrow-btn:hover {
  background: #5b7cff;
  color: white;
  transform: rotate(45deg);
}

/* =====================
   MEDIA QUERIES
====================== */

@media screen and (max-width: 1199.98px) {
  .breadcrumb:before {
    top: 24px;
    left: 24px;
  }

  .listing-item .listing-title {
    font-size: 20px;
  }

  .breadcrumb span.primary-right-round {
    top: 80px;
  }
}

@media screen and (max-width: 991.98px) {
  .about-usPage .about-us-para {
    font-size: 40px;
  }

  .about-img {
    width: 90%;
  }
  .wrap {
    padding: 40px 20px;
  }

  .two-col {
    grid-template-columns: 1fr;
  }

  .why-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .steps-about {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 28px;
  }

  .steps-about::before {
    display: none;
  }

  .book-section {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .book-visual {
    margin: 0 auto;
  }

  .tagline p {
    font-size: 18px;
  }
  h1 {
    font-size: 32px;
  }

  .aboutus-info {
    margin-bottom: 40px;
  }

  h2 {
    font-size: 30px;
  }

  .aboutus-info p:last-child {
    margin-bottom: 10px;
  }

  .slick-prev,
  .slick-next {
    top: 49% !important;
    width: 30px !important;
    height: 30px !important;
  }

  .slick-next {
    right: -14px;
    top: 48% !important;
  }

  .offer-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .offer-title {
    font-size: 34px;
  }
}

@media only screen and (max-width: 767.98px) {
  .wrap {
    padding: 28px 14px;
  }

  .intro,
  .story-card,
  .about-card,
  .how-section,
  .book-section,
  .tagline {
    padding: 22px 18px;
  }

  .intro h2,
  .about-card h3,
  .book-section h3,
  .how-section h3,
  .why-section h3 {
    font-size: 20px;
    line-height: 1.4;
  }

  .intro p,
  .story-item p,
  .about-card p,
  .step p,
  .why-card p,
  .book-section p {
    font-size: 13px;
    line-height: 1.7;
  }

  .why-grid {
    grid-template-columns: 1fr;
  }

  .steps-about{
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .step {
    padding: 0;
  }

  .book-section {
    gap: 18px;
  }

  .book-visual {
    width: 100%;
    min-height: 120px;
  }

  .tagline {
    padding: 26px 18px;
  }

  .tagline p {
    font-size: 17px;
    line-height: 1.5;
  }

  .tagline .sub {
    font-size: 12px;
  }

  .section-label {
    font-size: 18px;
  }
  .breadcrumb-list:before {
    top: 26px !important;
  }
  .breadcrumb span.primary-right-round {
    top: 37px !important;
  }
  .mission-bg {
    margin-top: 20px;
  }
  .section {
    padding: 15px 0;
  }
  .listing-item .listing-button {
    justify-content: start;
  }
  .para-about {
    font-size: 14px !important;
  }
  .user-book-now {
    padding-left: 5px;
  }
  .sports-icons {
    gap: 10px;
    margin-top: 16px;
  }

  .sports-icons span {
    width: 38px;
    height: 38px;
    font-size: 18px;
    border-radius: 10px;
  }

  .intro h2 span {
    font-size: 27px !important;
  }
  .intro h2 span {
    font-size: 27px !important;
  }
  .content {
    padding: 40px 0;
  }

  .aboutus-info {
    margin-bottom: 10px;
  }

  .aboutus-info .banner {
    margin-bottom: 15px;
  }

  h2 {
    font-size: 28px;
  }
  .Near-court .slick-slider .slick-prev {
    left: -5% !important;
  }
  .Near-court .slick-next {
    right: -1% !important;
  }
  .Near-court .slick-next,
  .blog-hero-section .slick-next {
    right: -30px !important;
    top: 49% !important;
  }
  .mobile-icon {
    padding-top: 27px !important;
  }
  .listing-details-group {
    height: 34vh;
    padding-top: 20px;
  }
  .listing-item .listing-details-group p {
    font-size: 15px !important;
  }
  .listining-para {
    padding-top: 20px !important;
  }
  .listing-title-page {
    font-size: 13px !important;
    padding-bottom: 23px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-usPage .about-us-heading {
    font-size: 22px;
  }

  .about-usPage .about-us-para {
    font-size: 34px;
  }

  .about-usContent .usContent {
    font-size: 32px;
  }

  .about-usPage .about-us-mainpra {
    font-size: 13px;
  }

  .about-img {
    margin-top: 60px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 767.98px) {
  .listing-item .listing-details-group p {
    margin-bottom: 0px;
    margin-top: 20px;
  }
}

@media (max-width: 600.98px) {
  .Near-court .slick-prev {
    transform: translate(63%, 40%) !important;
  }
  .Near-court .slick-next {
    transform: translate(-38%, 51%) !important;
  }
  .listing-item .listing-title {
    font-size: 16px !important;
  }
  .listing-item .listing-details-group p {
    padding-bottom: 0%;
  }
  .listing-details-group {
    height: 20vh !important;
    padding-top: 0px !important;
  }
  .Near-court .listing-item .listing-content {
    height: 215px !important;
  }
  .listing-title-page {
    font-size: 17px !important;
    padding-bottom: 14px;
  }
}

@media (max-width: 575.98px) {
  .featured-slider-group .featured-venues-item {
    padding: 0px 20px;
  }
  .Near-court .slick-prev {
    transform: translate(120%, 40%) !important;
  }
  .Near-court .slick-next {
    transform: translate(-88%, 51%) !important;
  }
  .offer-section {
    padding: 40px 20px;
  }

  .offer-grid {
    grid-template-columns: 1fr;
  }

  .offer-title {
    font-size: 28px;
  }

  .card-content h3 {
    font-size: 20px;
  }
}

@media screen and (max-width: 584.98px) {
  .listing-title-page {
    padding-bottom: 41px;
  }
}

@media screen and (max-width: 544.98px) {
  .listing-item .listing-button {
    padding: 6px 0 0px;
  }
}

@media (max-width: 480px) {
  .intro h2 {
    font-size: 18px;
  }

  .story-card h3,
  .about-card h3,
  .book-section h3,
  .how-section h3,
  .why-section h3 {
    font-size: 17px;
  }

  .why-card,
  .story-card,
  .about-card {
    border-radius: 12px;
  }

  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .why-icon {
    width: 34px;
    height: 34px;
    font-size: 15px;
  }

  .book-visual .big-icon {
    font-size: 30px;
  }

  .tagline p {
    font-size: 16px;
  }
  .sports-icons span {
    width: 34px;
    height: 34px;
    font-size: 16px;
  }
}

@media screen and (max-width: 430.98px) {
  .heading {
    text-align: left;
  }
  h2 {
    font-size: 23px !important;
  }
  .aboutus-info {
    margin-bottom: 15px;
  }
  .section-heading {
    margin: 0 0 25px;
  }
  .Near-court .slick-slider .slick-prev {
    left: -11% !important;
  }
  .Near-court .slick-next {
    right: -8% !important;
  }
}

@media(max-width:408.98px){
  .listing-details-group {
    height: 20vh !important;
  }
}

@media (max-width: 373.98px) {
  .about-tag {
    font-size: 11px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/AboutusPage.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mFAA6E;EAC7E,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;EAClF,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX;;;;;GAKC;EACD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;EACX;;;;;GAKC;EACD,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX;;;;;GAKC;EACD,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB,KAAK;;AAEL;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB;;;;;GAKC;EACD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oEAAkS;EAClS,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,QAAQ;EACR,yCAAyC;EACzC,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE,oEAAkS;EAClS,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,QAAQ;EACR,wCAAwC;EACxC,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EAGb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;wBAEwB;;AAExB;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;;;;;IAME,kBAAkB;EACpB;;EAEA;;;;;IAKE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;;;IAME,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* About-usPage */\n.text-white,\n.breadcrumb {\n  padding: 0px 34px;\n}\n\n.breadcrumb.breadcrumb-list {\n  background: url(../image/breadcrumb-bg2.webp) rgba(36, 29, 57, 0.8) no-repeat;\n  background-size: cover;\n}\n\n.breadcrumb-list {\n  /* background: url(../img/bg/breadcrumb-bg.png) rgba(36, 29, 57, 0.8) no-repeat; */\n  background-size: cover;\n  background-blend-mode: multiply;\n  padding: 60px 0;\n  position: relative;\n  margin-top: 70px;\n}\n\n.breadcrumb-list:before {\n  position: absolute;\n  top: 60px;\n  left: 40px;\n  width: 20px;\n  height: 20px;\n}\n\n.breadcrumb-list:before,\n.breadcrumb-list:after {\n  content: \"\";\n  background: linear-gradient(\n    105.55deg,\n    #085a6c -6.68%,\n    #269089 43.13%,\n    #7abc82 96.15%\n  );\n  border-radius: 100%;\n}\n\n.breadcrumb-list span.primary-right-round {\n  content: \"\";\n  position: absolute;\n  right: 50px;\n  bottom: 50px;\n  width: 13px;\n  height: 13px;\n  background: #23b33a;\n  border-radius: 13px;\n}\n\n.breadcrumb-list .container {\n  position: relative;\n}\n\n.breadcrumb-list h1 {\n  margin-bottom: 15px;\n}\n\n.breadcrumb-list ol {\n  position: relative;\n  color: #ffffff;\n}\n\n.breadcrumb-list ol li {\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n}\n\n.breadcrumb-list ol .active {\n  color: #ffffff;\n}\n\nul li {\n  list-style-type: none;\n}\n\n.featured-venues .blogstyle {\n  font-size: 1.5rem !important;\n}\n\n.breadcrumb-list ol:after {\n  position: absolute;\n  right: 0;\n  bottom: -76px;\n  width: 147px;\n  height: 74px;\n  content: \"\";\n  background: linear-gradient(\n    105.55deg,\n    #085a6c -6.68%,\n    #269089 43.13%,\n    #7abc82 96.15%\n  );\n  border-top-left-radius: 84px;\n  border-top-right-radius: 84px;\n}\n\n.breadcrumb-list:after {\n  content: \"\";\n  background: linear-gradient(\n    105.55deg,\n    #085a6c -6.68%,\n    #269089 43.13%,\n    #7abc82 96.15%\n  );\n  border-radius: 100%;\n}\n\n.breadcrumb-item a {\n  font-size: 16px !important;\n}\n\n.breadcrumb-item.active {\n  font-size: 16px !important;\n}\n\n.aboutus-info {\n  padding-top: 50px;\n  margin-bottom: 60px;\n}\n\n.corner-radius-10 {\n  border-radius: 10px;\n}\n\n.about-div{\n  padding: 40px 0px 0px 0px;\n}\n\n.aboutus-info .vision-mission {\n  margin-top: 40px;\n  padding: 0px 34px;\n}\n\n.aboutus-info .vision-mission h2 {\n  margin-bottom: 12px;\n  color: #192335;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.aboutus-info p {\n  margin-bottom: 10px;\n  .vision-mission p {\n    font-size: 15px;\n    color: #555;\n    line-height: 1.7;\n    margin-bottom: 12px;\n  }\n}\n\n.steps-about {\n  padding-left: 18px;\n}\n\n.steps-about li {\n  margin-bottom: 8px;\n  font-size: 14px;\n  list-style-type: disc;\n}\n\n.aboutus-info p:last-child {\n  margin-bottom: 40px;\n}\n\n.aboutus-info .vision-mission .mission-bg {\n  background: #00bfb4;\n  border-radius: 10px;\n  padding: 28px;\n  color: #ffffff;\n}\n\n.aboutus-info .vision-mission .mission-bg h2 {\n  color: #ffffff;\n  margin-top: 22px;\n  margin-bottom: 10px;\n}\n\n.aboutus-info .vision-mission h2 {\n  margin-bottom: 12px;\n}\n\n.aboutus-info .vision-mission .mission-bg p {\n  margin-bottom: 0;\n}\n\n.heading {\n  text-align: center;\n}\n\n/* ------------ */\n\n/*  */\n\n.featured-venues {\n  background: #f9f9f6;\n  position: relative;\n}\n\n.section-heading {\n  text-align: center;\n  margin: 0 0 40px;\n}\n\n.section-heading h2 {\n  position: relative;\n  margin: 0 0 15px;\n  z-index: 1;\n}\n\n.section-heading h2 span {\n  font-size: inherit;\n  background: linear-gradient(\n    105.55deg,\n    #085a6c -6.68%,\n    #269089 43.13%,\n    #7abc82 96.15%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.featured-slider-group {\n  padding: 15px 15px 20px;\n}\n\n.featured-slider-group .featured-venues-item {\n  padding-bottom: 20px;\n}\n\n.listing-item .listing-img {\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px 10px 0 0;\n}\n\n.slick-next:before,\n.slick-prev:before {\n  display: none !important;\n  content: none !important;\n}\n\n.slick-next:hover,\n.slick-prev:hover {\n  background-color: #097e52 !important;\n}\n\n.slick-next {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBvbHlsaW5lIHBvaW50cz0iOSA2IDE1IDEyIDkgMTgiLz48L3N2Zz4=\") !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-size: 20px 20px !important;\n  width: 36px !important;\n  height: 36px !important;\n  position: absolute !important;\n  top: 50%;\n  transform: translate(-24%, 0%) !important;\n  background-color: #ffffff !important;\n  border-radius: 50% !important;\n  z-index: 10 !important;\n  box-shadow: 0px -1px 23px rgba(212, 212, 212, 0.75) !important;\n}\n\n.slick-prev {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBvbHlsaW5lIHBvaW50cz0iMTUgNiA5IDEyIDE1IDE4Ii8+PC9zdmc+\") !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-size: 20px 20px !important;\n  left: -23px !important;\n  width: 36px !important;\n  height: 36px !important;\n  position: absolute !important;\n  top: 50%;\n  transform: translate(21%, 0%) !important;\n  background-color: #ffffff !important;\n  border-radius: 50% !important;\n  z-index: 10 !important;\n  box-shadow: 0px -1px 23px rgba(212, 212, 212, 0.75) !important;\n}\n\n.listing-item .list-reviews {\n  margin: 0 0 15px;\n}\n\n.listing-item .list-reviews {\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.listing-item .list-reviews span {\n  font-size: 14px;\n}\n\n.listing-item .rating-bg {\n  background: #ffaa00;\n  color: #ffffff;\n  border-radius: 5px;\n  margin-right: 7px;\n  width: 31px;\n  height: 28px;\n}\n\n.listing-item .rating-bg {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.listing-item .list-reviews span {\n  font-size: 14px;\n}\n\n.listing-item .list-reviews .fav-icon {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #eaedf0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: #192335;\n  display: flex;\n}\n\n\n\n.listing-item .listing-title a {\n  color: #192335;\n}\n\n.listing-item .listing-title-page {\n  margin: 0 0 15px;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n}\n\n.listing-item .listing-title-page h3 {\n  font-weight: 600;\n  font-size: 24px;\n}\n\n.listing-item .listing-title-page a {\n  color: #192335;\n}\n\n.listing-item .listing-details-group ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.listing-item .listing-details-group li {\n  color: #192335;\n  margin-bottom: 15px;\n}\n\n.listing-item .listing-content ul li span {\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n}\n\n.listing-item .listing-details-group li i {\n  font-size: 22px !important;\n}\n\n.listing-item .listing-details-group li .primary-text {\n  margin: 0 0 0 10px;\n  color: #097e52;\n}\n\n.listing-item .listing-button {\n  padding: 15px 0 0;\n  border-top: 1px solid #eaedf0;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n}\n\n.listing-item .listing-venue-owner a {\n  align-items: center;\n  display: flex;\n}\n\n.listing-venue-owner .navigation {\n  font-weight: 400;\n}\n\n.listing-venue-owner img {\n  border-radius: 50%;\n  border: 3px solid #eaedf0;\n  width: 45px;\n  height: 45px;\n  margin-right: 5px;\n}\n\n.user-book-now {\n  color: #6b7385;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.user-book-now span i {\n  color: #192335;\n}\n\n.listing-img img {\n  height: 200px;\n  object-fit: cover;\n  width: 100% !important;\n}\n\n/* cards */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.wrap {\n  background: #f4fafa;\n  padding: 48px 32px 0px 32px;\n}\n.inner {\n  margin: 0 auto;\n}\n\n/* TOP INTRO */\n.intro {\n  background: white;\n  border-radius: 14px;\n  border: 0.5px solid #d0eeea;\n  padding: 32px 36px;\n  margin-bottom: 28px;\n}\n.intro h2 {\n  font-size: 24px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 14px;\n}\n.intro h2 span {\n  color: #0f9b8e;\n}\n.intro p {\n  font-size: 15px;\n  color: #4a6b68;\n  line-height: 1.8;\n  margin-bottom: 8px;\n}\n.intro p:last-child {\n  margin-bottom: 0;\n}\n\n/* TWO COL */\n.two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 28px;\n}\n\n/* STORY */\n.story-card {\n  background: white;\n  border-radius: 14px;\n  border: 0.5px solid #d0eeea;\n  padding: 28px;\n}\n.section-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 17px;\n  font-weight: 500;\n  color: #0f9b8e;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n.section-label::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 2px;\n  background: #0f9b8e;\n  border-radius: 2px;\n}\n.story-card h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 16px;\n}\n.story-item {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n.story-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #0f9b8e;\n  flex-shrink: 0;\n  margin-top: 7px;\n}\n.story-item p {\n  font-size: 13px;\n  color: #4a6b68;\n  line-height: 1.7;\n}\n\n/* ABOUT BOX */\n.about-card {\n  background: #0f9b8e;\n  border-radius: 14px;\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.about-card h3 {\n  font-size: 23px;\n  font-weight: 500;\n  color: white;\n}\n.about-card p {\n  font-size: 17px;\n  color: rgba(255, 255, 255, 0.82);\n  line-height: 1.8;\n}\n.about-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 4px;\n}\n.about-tag {\n  font-size: 14px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  border: 0.5px solid rgba(255, 255, 255, 0.3);\n}\n\n/* HOW IT WORKS */\n.how-section {\n  background: white;\n  border-radius: 14px;\n  border: 0.5px solid #d0eeea;\n  padding: 28px 32px;\n  margin-bottom: 28px;\n}\n.how-section h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 6px;\n}\n.how-section .sub {\n  font-size: 15px;\n  color: #4a6b68;\n  margin-bottom: 24px;\n}\n.steps-about {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n  position: relative;\n}\n.steps-about::before {\n  content: \"\";\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  right: 15px;\n  height: 1.5px;\n  background: #c2e8e4;\n  z-index: 0;\n}\n.step {\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  padding: 0 8px;\n}\n.step-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #0f9b8e;\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n  border: 3px solid #f4fafa;\n}\n.step h4 {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 4px;\n}\n.step p {\n  font-size: 12px;\n  color: #4a6b68;\n  line-height: 1.6;\n}\n\n/* WHY CHOOSE */\n.why-section {\n  margin-bottom: 28px;\n}\n.why-section h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 6px;\n}\n.why-section .sub {\n  font-size: 15px;\n  color: #4a6b68;\n  margin-bottom: 20px;\n}\n.why-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n.why-card {\n  background: white;\n  border-radius: 14px;\n  border: 0.5px solid #d0eeea;\n  padding: 20px;\n}\n.why-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #e6f9f7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  margin-bottom: 12px;\n}\n.why-card h4 {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 5px;\n}\n.why-card p {\n  font-size: 12px;\n  color: #4a6b68;\n  line-height: 1.65;\n}\n\n/* BOOK TODAY */\n.book-section {\n  background: white;\n  border-radius: 14px;\n  border: 0.5px solid #d0eeea;\n  padding: 28px 32px;\n  margin-bottom: 28px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 24px;\n  align-items: center;\n}\n.book-section h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #0a2e2b;\n  margin-bottom: 10px;\n}\n.book-section p {\n  font-size: 15px;\n  color: #4a6b68;\n  line-height: 1.75;\n  margin-bottom: 8px;\n}\n.book-section p:last-of-type {\n  margin-bottom: 0;\n}\n.book-visual {\n  background: #e6f9f7;\n  border-radius: 12px;\n  width: 140px;\n  min-height: 130px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 16px;\n}\n.book-visual .big-icon {\n  font-size: 36px;\n}\n.book-visual p {\n  font-size: 11px;\n  color: #0f9b8e;\n  text-align: center;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n/* TAGLINE */\n.tagline {\n  background: #0a2e2b;\n  border-radius: 14px;\n  padding: 32px;\n  text-align: center;\n}\n.tagline p {\n  font-size: 20px;\n  font-weight: 500;\n  color: white;\n  letter-spacing: 0.3px;\n}\n.tagline p span {\n  color: #4ecdc4;\n}\n.tagline .sub {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.45);\n  margin-top: 8px;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n/* SPORTS ICONS */\n.sports-icons {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n  flex-wrap: wrap;\n}\n\n.sports-icons span {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 0px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 20px;\n  transition: 0.3s ease;\n  cursor: pointer;\n}\n\n.sports-icons span:hover {\n  transform: translateY(-3px);\n  background: rgba(255, 255, 255, 0.22);\n}\n\n/* OfferCards.css */\n\n.offer-section {\n  padding: 30px 40px;\n  background: #f7f9fc;\n  margin: 20px 0px;\n}\n\n.offer-title {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 600;\n  color: #092642;\n  margin-bottom: 50px;\n  font-family: \"Outfit\", sans-serif;\n}\n\n.offer-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.offer-card {\n  position: relative;\n  background: #ffffff;\n  border-radius: 22px;\n  padding: 30px 24px;\n  overflow: hidden;\n  min-height: 226px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.offer-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);\n}\n\n.wave-bg {\n  position: absolute;\n  bottom: -10px;\n  left: -20px;\n  width: 140%;\n  height: 90px;\n  background: #eef4ff;\n  border-radius: 50%;\n}\n\n.card-content {\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.card-content h3 {\n  font-size: 18px;\n  color: #495E76;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.arrow-btn {\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 50%;\n  background: #eef3ff;\n  color: #5b7cff;\n  font-size: 22px;\n  cursor: pointer;\n  align-self: flex-end;\n  transition: all 0.3s ease;\n}\n\n.arrow-btn:hover {\n  background: #5b7cff;\n  color: white;\n  transform: rotate(45deg);\n}\n\n/* =====================\n   MEDIA QUERIES\n====================== */\n\n@media screen and (max-width: 1199.98px) {\n  .breadcrumb:before {\n    top: 24px;\n    left: 24px;\n  }\n\n  .listing-item .listing-title {\n    font-size: 20px;\n  }\n\n  .breadcrumb span.primary-right-round {\n    top: 80px;\n  }\n}\n\n@media screen and (max-width: 991.98px) {\n  .about-usPage .about-us-para {\n    font-size: 40px;\n  }\n\n  .about-img {\n    width: 90%;\n  }\n  .wrap {\n    padding: 40px 20px;\n  }\n\n  .two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .why-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .steps-about {\n    grid-template-columns: repeat(2, 1fr);\n    row-gap: 28px;\n  }\n\n  .steps-about::before {\n    display: none;\n  }\n\n  .book-section {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n\n  .book-visual {\n    margin: 0 auto;\n  }\n\n  .tagline p {\n    font-size: 18px;\n  }\n  h1 {\n    font-size: 32px;\n  }\n\n  .aboutus-info {\n    margin-bottom: 40px;\n  }\n\n  h2 {\n    font-size: 30px;\n  }\n\n  .aboutus-info p:last-child {\n    margin-bottom: 10px;\n  }\n\n  .slick-prev,\n  .slick-next {\n    top: 49% !important;\n    width: 30px !important;\n    height: 30px !important;\n  }\n\n  .slick-next {\n    right: -14px;\n    top: 48% !important;\n  }\n\n  .offer-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .offer-title {\n    font-size: 34px;\n  }\n}\n\n@media only screen and (max-width: 767.98px) {\n  .wrap {\n    padding: 28px 14px;\n  }\n\n  .intro,\n  .story-card,\n  .about-card,\n  .how-section,\n  .book-section,\n  .tagline {\n    padding: 22px 18px;\n  }\n\n  .intro h2,\n  .about-card h3,\n  .book-section h3,\n  .how-section h3,\n  .why-section h3 {\n    font-size: 20px;\n    line-height: 1.4;\n  }\n\n  .intro p,\n  .story-item p,\n  .about-card p,\n  .step p,\n  .why-card p,\n  .book-section p {\n    font-size: 13px;\n    line-height: 1.7;\n  }\n\n  .why-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .steps-about{\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .step {\n    padding: 0;\n  }\n\n  .book-section {\n    gap: 18px;\n  }\n\n  .book-visual {\n    width: 100%;\n    min-height: 120px;\n  }\n\n  .tagline {\n    padding: 26px 18px;\n  }\n\n  .tagline p {\n    font-size: 17px;\n    line-height: 1.5;\n  }\n\n  .tagline .sub {\n    font-size: 12px;\n  }\n\n  .section-label {\n    font-size: 18px;\n  }\n  .breadcrumb-list:before {\n    top: 26px !important;\n  }\n  .breadcrumb span.primary-right-round {\n    top: 37px !important;\n  }\n  .mission-bg {\n    margin-top: 20px;\n  }\n  .section {\n    padding: 15px 0;\n  }\n  .listing-item .listing-button {\n    justify-content: start;\n  }\n  .para-about {\n    font-size: 14px !important;\n  }\n  .user-book-now {\n    padding-left: 5px;\n  }\n  .sports-icons {\n    gap: 10px;\n    margin-top: 16px;\n  }\n\n  .sports-icons span {\n    width: 38px;\n    height: 38px;\n    font-size: 18px;\n    border-radius: 10px;\n  }\n\n  .intro h2 span {\n    font-size: 27px !important;\n  }\n  .intro h2 span {\n    font-size: 27px !important;\n  }\n  .content {\n    padding: 40px 0;\n  }\n\n  .aboutus-info {\n    margin-bottom: 10px;\n  }\n\n  .aboutus-info .banner {\n    margin-bottom: 15px;\n  }\n\n  h2 {\n    font-size: 28px;\n  }\n  .Near-court .slick-slider .slick-prev {\n    left: -5% !important;\n  }\n  .Near-court .slick-next {\n    right: -1% !important;\n  }\n  .Near-court .slick-next,\n  .blog-hero-section .slick-next {\n    right: -30px !important;\n    top: 49% !important;\n  }\n  .mobile-icon {\n    padding-top: 27px !important;\n  }\n  .listing-details-group {\n    height: 34vh;\n    padding-top: 20px;\n  }\n  .listing-item .listing-details-group p {\n    font-size: 15px !important;\n  }\n  .listining-para {\n    padding-top: 20px !important;\n  }\n  .listing-title-page {\n    font-size: 13px !important;\n    padding-bottom: 23px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .about-usPage .about-us-heading {\n    font-size: 22px;\n  }\n\n  .about-usPage .about-us-para {\n    font-size: 34px;\n  }\n\n  .about-usContent .usContent {\n    font-size: 32px;\n  }\n\n  .about-usPage .about-us-mainpra {\n    font-size: 13px;\n  }\n\n  .about-img {\n    margin-top: 60px;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 767.98px) {\n  .listing-item .listing-details-group p {\n    margin-bottom: 0px;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 600.98px) {\n  .Near-court .slick-prev {\n    transform: translate(63%, 40%) !important;\n  }\n  .Near-court .slick-next {\n    transform: translate(-38%, 51%) !important;\n  }\n  .listing-item .listing-title {\n    font-size: 16px !important;\n  }\n  .listing-item .listing-details-group p {\n    padding-bottom: 0%;\n  }\n  .listing-details-group {\n    height: 20vh !important;\n    padding-top: 0px !important;\n  }\n  .Near-court .listing-item .listing-content {\n    height: 215px !important;\n  }\n  .listing-title-page {\n    font-size: 17px !important;\n    padding-bottom: 14px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .featured-slider-group .featured-venues-item {\n    padding: 0px 20px;\n  }\n  .Near-court .slick-prev {\n    transform: translate(120%, 40%) !important;\n  }\n  .Near-court .slick-next {\n    transform: translate(-88%, 51%) !important;\n  }\n  .offer-section {\n    padding: 40px 20px;\n  }\n\n  .offer-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .offer-title {\n    font-size: 28px;\n  }\n\n  .card-content h3 {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 584.98px) {\n  .listing-title-page {\n    padding-bottom: 41px;\n  }\n}\n\n@media screen and (max-width: 544.98px) {\n  .listing-item .listing-button {\n    padding: 6px 0 0px;\n  }\n}\n\n@media (max-width: 480px) {\n  .intro h2 {\n    font-size: 18px;\n  }\n\n  .story-card h3,\n  .about-card h3,\n  .book-section h3,\n  .how-section h3,\n  .why-section h3 {\n    font-size: 17px;\n  }\n\n  .why-card,\n  .story-card,\n  .about-card {\n    border-radius: 12px;\n  }\n\n  .step-circle {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .why-icon {\n    width: 34px;\n    height: 34px;\n    font-size: 15px;\n  }\n\n  .book-visual .big-icon {\n    font-size: 30px;\n  }\n\n  .tagline p {\n    font-size: 16px;\n  }\n  .sports-icons span {\n    width: 34px;\n    height: 34px;\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 430.98px) {\n  .heading {\n    text-align: left;\n  }\n  h2 {\n    font-size: 23px !important;\n  }\n  .aboutus-info {\n    margin-bottom: 15px;\n  }\n  .section-heading {\n    margin: 0 0 25px;\n  }\n  .Near-court .slick-slider .slick-prev {\n    left: -11% !important;\n  }\n  .Near-court .slick-next {\n    right: -8% !important;\n  }\n}\n\n@media(max-width:408.98px){\n  .listing-details-group {\n    height: 20vh !important;\n  }\n}\n\n@media (max-width: 373.98px) {\n  .about-tag {\n    font-size: 11px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
